import { UnitCatalogEntry } from './types';

// --- Pipeline & display constants ---

export const MIN_PER_HOUR = 60;
export const SEC_PER_MIN = 60;
export const NO_VALUE = '--';
export const FALLBACK_PRECISION = 2;
export const PSIG_TO_INHG_FACTOR = 2.03602;

/** Threshold for K-suffix compact display (axis labels, chart ticks) */
export const COMPACT_NUMBER_K_THRESHOLD = 1000;
/** Threshold for M-suffix compact display (axis labels, chart ticks) */
export const COMPACT_NUMBER_M_THRESHOLD = 1000000;
/** Values below this use one decimal place in compact display */
export const COMPACT_NUMBER_DECIMAL_THRESHOLD = 100;

/** 8-point compass labels clockwise from North */
export const WIND_DIRECTIONS_CLOCKWISE_FROM_N = [
  'N',
  'NE',
  'E',
  'SE',
  'S',
  'SW',
  'W',
  'NW',
] as const;

/** Display label written to formatted output for MPH values */
export const MPH_OUTPUT_LABEL = 'MPH';

/** Display label written to formatted output for angular degree values */
export const DEGREE_OUTPUT_LABEL = '°';

/** Display labels written to formatted output for PSI gauge values */
export const PSI_OUTPUT_LABELS = {
  PSIG: 'PSIG',
  INHG: 'inHG',
} as const;

/** Display label written to formatted output for PID values */
export const PID_OUTPUT_LABEL = 'PID';

/** Lowercase, de-duplicated lookup keys for a catalog entry (name, asciiSymbol, aliases). */
export function lookupKeys(entry: UnitCatalogEntry): string[] {
  return Array.from(
    new Set(
      [entry.name, entry.asciiSymbol, ...(entry.aliases ?? [])]
        .filter(Boolean)
        .map((key) => key!.toLowerCase())
    )
  );
}
